import { useState } from "react";
import { Upload, File as FileIcon, X, Loader2, Image as ImageIcon } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export const FileUpload = ({ files = [], onChange, testId = "file-upload", accept }) => {
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (fileList) => {
    const arr = Array.from(fileList);
    setUploading(true);
    try {
      const uploaded = [];
      for (const file of arr) {
        const form = new FormData();
        form.append("file", file);
        const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
        uploaded.push(data);
      }
      onChange([...(files || []), ...uploaded]);
      toast.success(`${uploaded.length} file(s) uploaded`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const remove = (id) => onChange(files.filter((f) => f.id !== id));
  const isImage = (f) => (f.content_type || "").startsWith("image/");

  return (
    <div data-testid={testId}>
      <label className="flex cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-border bg-secondary/40 px-6 py-8 text-center transition-colors hover:border-primary hover:bg-secondary">
        {uploading ? (
          <Loader2 className="mb-2 h-6 w-6 animate-spin text-primary" />
        ) : (
          <Upload className="mb-2 h-6 w-6 text-muted-foreground" />
        )}
        <span className="text-sm font-medium">Click to upload images or documents</span>
        <span className="text-xs text-muted-foreground">PNG, JPG, PDF, DOCX — up to 15MB</span>
        <input type="file" multiple accept={accept} className="hidden" data-testid={`${testId}-input`}
          onChange={(e) => e.target.files.length && handleFiles(e.target.files)} disabled={uploading} />
      </label>
      {files.length > 0 && (
        <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
          {files.map((f) => (
            <div key={f.id} className="flex items-center gap-2 rounded-lg border bg-card p-2" data-testid={`${testId}-item-${f.id}`}>
              {isImage(f) ? <ImageIcon className="h-4 w-4 shrink-0 text-primary" /> : <FileIcon className="h-4 w-4 shrink-0 text-primary" />}
              <span className="flex-1 truncate text-xs">{f.filename}</span>
              <button type="button" onClick={() => remove(f.id)} className="rounded p-1 hover:bg-secondary" data-testid={`${testId}-remove-${f.id}`}>
                <X className="h-3.5 w-3.5" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
